import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import ChatVoiceError from "@mapmycustomers/shared/enum/chat/ChatVoiceError";
import ChatVoiceHint from "@mapmycustomers/shared/enum/chat/ChatVoiceHint";
import ChatMessage from "@mapmycustomers/shared/types/chat/ChatMessage";

// The AudioContext this conceptually carries is not serializable and has no business in a
// payload — the click handler leaves it in currentVoiceCapture.ts and the saga takes it.
// `startedAt` is performance.now(), passed in so the reducer stays a pure function of its input.
export const startVoiceRecording = createAction("@chat/voice/startVoiceRecording")<{
  startedAt: number;
}>();

export const cancelVoiceRecording = createAction("@chat/voice/cancelVoiceRecording")();

export const pauseVoiceRecording = createAction("@chat/voice/pauseVoiceRecording")<{
  at: number;
}>();

export const resumeVoiceRecording = createAction("@chat/voice/resumeVoiceRecording")<{
  at: number;
}>();

export const finishVoiceRecording = createAction("@chat/voice/finishVoiceRecording")<{
  at: number;
}>();

export const setVoicePart = createAction("@chat/voice/setVoicePart")<{
  seq: number;
  text: string;
}>();

export const setVoiceHint = createAction("@chat/voice/setVoiceHint")<{
  hint: ChatVoiceHint;
}>();

export const setVoiceError = createAction("@chat/voice/setVoiceError")<{
  error: ChatVoiceError;
}>();

export const enterVoiceReview = createAction("@chat/voice/enterVoiceReview")();

export const sendVoiceMessage = createAsyncAction(
  "@chat/voice/sendVoiceMessage/request",
  "@chat/voice/sendVoiceMessage/success",
  "@chat/voice/sendVoiceMessage/failure"
)<{ durationMs: number; text: string }, { id: ChatMessage["id"] }, undefined>();

export type ChatVoiceActions = ActionType<
  | typeof cancelVoiceRecording
  | typeof enterVoiceReview
  | typeof finishVoiceRecording
  | typeof pauseVoiceRecording
  | typeof resumeVoiceRecording
  | typeof sendVoiceMessage
  | typeof setVoiceError
  | typeof setVoiceHint
  | typeof setVoicePart
  | typeof startVoiceRecording
>;
